import DynamicNativeBuilder from './DynamicNativeBuilder/DynamicNativeBuilder';

const dynamicNativeBuilder = (
  reactDirective,
  CreativeService,
  RenderService,
  DcoAssetsService
) => {
  return reactDirective(
    DynamicNativeBuilder,
    undefined,
    {
      restrict: 'E'
    },
    {
      CreativeService,
      RenderService,
      DcoAssetsService
    }
  );
};

dynamicNativeBuilder.$inject = [
  'reactDirective',
  'CreativeService',
  'RenderService',
  'DcoAssetsService'
];

export default dynamicNativeBuilder;
